exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*\n    Colors named using http://chir.ag/projects/name-that-color/\n*/\n/******************************\n    Monochrome, Greys\n*******************************/\n/* could be f9f9f9 */\n/******************************\n    Standard Colors\n*******************************/\n.baltic-sea {\n  background-color: #2d2c30; }\n\n.dates-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-left: -20px; }\n  .dates-list .date-box {\n    font-weight: 300;\n    padding: 10px;\n    font-size: 14px;\n    background-color: #fff;\n    width: 220px;\n    margin: 20px;\n    border-left: 6px solid #ad974f; }\n    .dates-list .date-box .dl-title {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 20px; }\n    .dates-list .date-box .dl-description {\n      margin-top: 3px; }\n    .dates-list .date-box .dl-date {\n      margin-top: 5px;\n      color: #ad974f; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/pages/Dates/Dates.scss
// module id = 931
// module chunks = 0